import React from 'react'

const HeaderSocials = () => {
  return (
    <div className="home__socials">
      <a href="https://www.linkedin.com/in/nikhil-kumar-225108228/" className="home__social-link" target="_blank">
            <i class="fa-brands fa-linkedin"></i>
        </a>
      
        <a href="https://leetcode.com/brahmanboy/" className="home__social-link" target="_blank">
            <i class="icon-badge"></i>
        </a>

        <a href="https://github.com/Nikhil-180" className="home__social-link" target="_blank">
            <i class="fa-brands fa-github"></i>
        </a>


        <a href="https://www.hackerrank.com/brahmanboy18" className="home__social-link" target="_blank">
            <i class="icon-badge"></i>
        </a>

        

        
    </div>
  )
}

export default HeaderSocials